// assets/delhivery-tracker.js

(function () {
  // 🔴 If your Vercel URL changes, update it here
  const API_BASE =
    "https://delhivery-tracking-two.vercel.app/api/delhivery-track";

  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("delhivery-form");
    const resultBox = document.getElementById("delhivery-result");
    const input = document.getElementById("delhivery-awb");

    if (!form || !resultBox || !input) return; // run only on Track Order page

    const button = form.querySelector("button");

    async function handleSubmit(e) {
      e.preventDefault();

      const awb = (input.value || "").trim();
      if (!awb) {
        showMessage("Please enter your tracking number.");
        return;
      }

      setLoading(true);
      showMessage("Fetching status…");

      try {
        const res = await fetch(
          API_BASE + "?awb=" + encodeURIComponent(awb)
        );

        if (!res.ok) {
          throw new Error("API error");
        }

        const data = await res.json();
        console.log("Delhivery response:", data);

        const shipmentData =
          data.ShipmentData && data.ShipmentData.length
            ? data.ShipmentData[0]
            : null;
        const shipment = shipmentData ? shipmentData.Shipment : null;

        if (!shipment) {
          showMessage("No shipment found for this tracking number.");
          return;
        }

        const statusObj = shipment.Status || {};
        const scansArr = shipment.Scans || [];
        const consignee = shipment.Consignee || {};

        const currentStatus = statusObj.Status || "Status not available";
        const statusTime = statusObj.StatusDateTime || "";
        const statusLocation = statusObj.StatusLocation || "";
        const waybill = shipment.AWB || awb;
        const expectedDelivery = shipment.ExpectedDeliveryDate || "";
        const pickupDate =
          shipment.PickUpDate || shipment.PickedupDate || "";

        const origin = shipment.Origin || "";
        const destination = shipment.Destination || "";
        const pickupLocation = shipment.PickupLocation || "";
        const orderType = shipment.OrderType || "";

        const invoiceAmount =
          typeof shipment.InvoiceAmount !== "undefined"
            ? shipment.InvoiceAmount
            : null;
        const codAmount =
          typeof shipment.CODAmount !== "undefined"
            ? shipment.CODAmount
            : null;

        const orderId = shipment.ReferenceNo || "—";

        const consigneeName = consignee.Name || "";
        const consigneeCity = consignee.City || "";
        const consigneeState = consignee.State || "";

        let html = "";
        html += `<p class="status-title">Current status: ${currentStatus}</p>`;

        html += '<div class="summary-grid">';

        html += `<div class="summary-item">
                  <strong>Order ID</strong>
                  <span>${orderId}</span>
                </div>`;

        html += `<div class="summary-item">
                  <strong>Tracking ID</strong>
                  <span>${waybill}</span>
                </div>`;

        if (origin || destination) {
          html += `<div class="summary-item">
                    <strong>Route</strong>
                    <span>${origin} → ${destination}</span>
                  </div>`;
        }

        if (consigneeName || consigneeCity || consigneeState) {
          html += `<div class="summary-item">
                    <strong>Consignee</strong>
                    <span>${consigneeName} (${consigneeCity}, ${consigneeState})</span>
                  </div>`;
        }

        if (orderType) {
          html += `<div class="summary-item">
                    <strong>Order Type</strong>
                    <span>${orderType}</span>
                  </div>`;
        }

        if (invoiceAmount !== null) {
          html += `<div class="summary-item">
                    <strong>Invoice Amount</strong>
                    <span>₹${invoiceAmount}</span>
                  </div>`;
        }

        if (codAmount !== null) {
          html += `<div class="summary-item">
                    <strong>COD Amount</strong>
                    <span>₹${codAmount}</span>
                  </div>`;
        }

        if (pickupDate) {
          html += `<div class="summary-item">
                    <strong>Pickup Date</strong>
                    <span>${pickupDate}</span>
                  </div>`;
        }

        if (expectedDelivery) {
          html += `<div class="summary-item">
                    <strong>Expected Delivery</strong>
                    <span>${expectedDelivery}</span>
                  </div>`;
        }

        if (statusLocation) {
          html += `<div class="summary-item">
                    <strong>Current Location</strong>
                    <span>${statusLocation}</span>
                  </div>`;
        }

        if (statusTime) {
          html += `<div class="summary-item">
                    <strong>Last Updated</strong>
                    <span>${statusTime}</span>
                  </div>`;
        }

        if (pickupLocation) {
          html += `<div class="summary-item">
                    <strong>Pickup Location</strong>
                    <span>${pickupLocation}</span>
                  </div>`;
        }

        html += "</div>";

        if (scansArr.length) {
          html += "<h4>Tracking history</h4>";
          html += "<ul>";
          scansArr.forEach((scan) => {
            const d = scan.ScanDetail || scan;
            const text = d.Instructions || d.Scan || "Update";
            const time = d.ScanDateTime || "";
            const loc = d.ScannedLocation || "";
            html += "<li>";
            html += `<div>${text}</div>`;
            if (time) html += `<small>${time}</small>`;
            if (loc) html += `<br><small>${loc}</small>`;
            html += "</li>";
          });
          html += "</ul>";
        }

        showHtml(html);
      } catch (err) {
        console.error(err);
        showMessage(
          "Could not fetch tracking details right now. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    }

    function showMessage(msg) {
      resultBox.style.display = "block";
      resultBox.innerHTML = `<p>${msg}</p>`;
    }

    function showHtml(html) {
      resultBox.style.display = "block";
      resultBox.innerHTML = html;
    }

    function setLoading(isLoading) {
      button.disabled = isLoading;
    }

    form.addEventListener("submit", handleSubmit);
  });
})();
